import { createSelector } from '@ngrx/store';

import { countLinkRequests } from '../../../link-requests/store/selectors/link-requests';
import { getUISiteMaxCount } from '../../../site-list/store/selectors/ui';

export const countResults = createSelector(getUISiteMaxCount, countLinkRequests, (nbSites, nbLinkRequests) => ({
    nbSites,
    nbLinkRequests,
}));
